<template>

<div
    id="wheel"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div
          class="sticky-top container-fluid"
          data-padding-right=""
          data-margin-right=""
          style=""
        >
          <div
            class="align-items-center justify-content-center py-0 modalTopClose row"
          >
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="font-size: 20px;"
                >
                  <path
                    fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img
                    alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์"
                    loading="eager"
                    width="190"
                    height="48"
                    decoding="async"
                    data-nimg="1"
                    class="animated fadeInUp img-fluid"
                    src="/static/img/logo/logo.png"
                    style="color: transparent;"
                  />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img
                  src="/static/img/landing/closeIcon.png"
                  width="40"
                  height="40"
                  alt="ปิด"
                  class=""
                />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>กงล้อ</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">
            <h2 class="creditNum">
                      เหรียญ :
                      <span id="point_for_wheel">{{
                        UserInfo.internalWallet.prizeWallet
                      }}</span>
                    </h2>
                    <div class="" style="position: relative;padding: 20px;">
                      <div
                        class="containSpin"
                        style="width: 100%;position: relative;"
                        v-html="withHTML"
                      ></div>
                    </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>


   
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { open } from "@/services/modules/spin.js";
import api from '@/services/index.js'

export default {
  name: "WheelForm",
  mixins: [UserInfoMixins],

  data() {
    return {withHTML:""};
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    async open() {
      setTimeout(async () => {
        await open((res) => {
          if (res.status) {
            return this.$swal.fire(res.message, '', 'success')
          } else {
            return this.$swal.fire(res.message, '', 'error')
          }
        })
      }, 1500)
    },
    importScript: (url) => {
      const plugin = document.createElement("script");
      plugin.setAttribute("src", url);
      plugin.async = true;
      document.head.append(plugin);
    },
    importScriptData: async (code) => {
      const plugin = document.createElement("script");
      plugin.text = code;
      plugin.async = true;
      document.head.appendChild(plugin);
    },
  },

  async mounted() {
    await this.importScriptData(await api.get('/wheel-script/script'))
    await this.importScript("https://cdn.betflixgo.com/js/flix/1.478.617cfd6e.js")
    await api.get("/wheel-script/html5").then((v) => {
      this.withHTML = v
    })
  },
}
</script>
<style scoped>
.modal-dialog[data-v-6c8d75ed] {
  min-width: 720px;
}

.modal-dialog .modal-content[data-v-6c8d75ed] {
  background-color: #151515;
  border-radius: 10px;
  box-shadow: 0 0 5px #000;
}

.modal-dialog .modal-content .modal-body .header-label[data-v-6c8d75ed] {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  padding: 0.8rem 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  border-radius: 4px;
}

.modal-dialog .modal-content .modal-header .btn-close[data-v-6c8d75ed] {
  color: #fff;
  background: none;
  width: auto;
  height: auto;
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5)
    calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5)
    calc(var(--bs-modal-header-padding-x) * -0.5)
    calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-dialog .modal-content .modal-header[data-v-6c8d75ed] {
  color: #fff;
  border-bottom: none;
  padding: 0.225rem 0.5rem;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid
    var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-dialog .modal-content .modal-body[data-v-6c8d75ed] {
  padding-top: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

#cashback .blog-cashback[data-v-4ad267e1] {
  padding: 1rem 1rem 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}

.blog-data-amount h2[data-v-4ad267e1] {
  color: #f7ac03;
  font-weight: 600;
  font-size: 2.5rem;
  margin: 0;
}

table,
td,
th {
  border: 1px solid;
  padding: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 5px;
}

#comp-list-bonus-other {
  display: grid;
  gap: 7px;
  grid-template-areas: ". . ";
}
</style>



// WEBPACK FOOTER //
// src/components/form/WheelForm.vue